import { render, staticRenderFns } from "./ShowCategory.vue?vue&type=template&id=2301e1f9&scoped=true"
import script from "./ShowCategory.vue?vue&type=script&lang=js"
export * from "./ShowCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2301e1f9",
  null
  
)

export default component.exports